import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const SSRS = () => {
  return (
    <StartInterviewLayout type="ssrs"/>
  )
}

export default SSRS;